
export default {
  name: "GrupoEmpresaConsolidado",
  data() {
    const hoje = new Date();
    const inicioMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

    return {
      carregandoInicial: true,
      carregando: false,
      grupo: null,
      dashboard: null,
      filtros: {
        inicio: this.formatarDataInput(inicioMes),
        fim: this.formatarDataInput(hoje),
        empresas: [],
      },
    };
  },
  computed: {
    opcoesEmpresas() {
      return (this.grupo?.membros || [])
        .filter((membro) => membro.ativo !== false && membro.empresa)
        .map((membro) => ({
          value: Number(membro.id_empresa),
          text: `${this.nomeEmpresa(membro.empresa)} (${membro.tipo})`,
          nome: this.nomeEmpresa(membro.empresa),
          tipo: membro.tipo,
        }));
    },
    resumoEmpresasSelecionadas() {
      const quantidade = this.filtros.empresas.length;
      if (quantidade === 0) return "Nenhuma empresa";
      if (quantidade === this.opcoesEmpresas.length) return "Todas as empresas";
      if (quantidade === 1) {
        return (
          this.opcoesEmpresas.find(
            (empresa) => empresa.value === this.filtros.empresas[0]
          )?.nome || "1 empresa"
        );
      }

      return `${quantidade} empresas selecionadas`;
    },
    cards() {
      const totais = this.dashboard?.totais || {};

      return [
        {
          key: "faturamento",
          label: "Faturamento Total",
          valor: totais.faturamento,
          detalhe: `${totais.quantidade_vendas || 0} venda(s)`,
        },
        {
          key: "resultado",
          label: "Resultado do período",
          valor: totais.resultado_periodo,
          className: this.classeResultado(totais.resultado_periodo),
          detalhe: `${this.formatarMoeda(
            totais.receitas_recebidas
          )} recebido · ${this.formatarMoeda(totais.despesas_pagas)} pago`,
        },
        {
          key: "receber",
          label: "Contas a receber",
          valor: totais.contas_receber,
          detalhe: `${this.formatarMoeda(
            totais.contas_receber_vencidas
          )} vencidos`,
        },
        {
          key: "pagar",
          label: "Contas a pagar",
          valor: totais.contas_pagar,
          detalhe: `${this.formatarMoeda(
            totais.contas_pagar_vencidas
          )} vencidos`,
        },
      ];
    },
    relatorioVendas() {
      const faturamentoTotal = Number(this.dashboard?.totais?.faturamento || 0);

      return (this.dashboard?.empresas || []).map((empresa) => {
        const faturamento = Number(empresa.metricas?.faturamento || 0);
        const quantidade = Number(empresa.metricas?.quantidade_vendas || 0);

        return {
          id_empresa: empresa.id_empresa,
          nome: this.nomeEmpresa(empresa),
          tipo: empresa.tipo,
          quantidade_vendas: quantidade,
          faturamento,
          ticket_medio: quantidade > 0 ? faturamento / quantidade : 0,
          participacao:
            faturamentoTotal > 0 ? (faturamento / faturamentoTotal) * 100 : 0,
        };
      });
    },
    relatorioFinanceiro() {
      return (this.dashboard?.empresas || []).map((empresa) => ({
        id_empresa: empresa.id_empresa,
        nome: this.nomeEmpresa(empresa),
        tipo: empresa.tipo,
        receitas_recebidas: Number(empresa.metricas?.receitas_recebidas || 0),
        despesas_pagas: Number(empresa.metricas?.despesas_pagas || 0),
        resultado_periodo: Number(empresa.metricas?.resultado_periodo || 0),
        contas_receber: Number(empresa.metricas?.contas_receber || 0),
        contas_receber_vencidas: Number(
          empresa.metricas?.contas_receber_vencidas || 0
        ),
        contas_pagar: Number(empresa.metricas?.contas_pagar || 0),
        contas_pagar_vencidas: Number(
          empresa.metricas?.contas_pagar_vencidas || 0
        ),
      }));
    },
    relatorioBancos() {
      return (this.dashboard?.bancos || [])
        .map((banco) => ({
          id_banco: Number(banco.id_banco),
          id_empresa: Number(banco.id_empresa),
          empresa: this.nomeEmpresa(banco.empresa),
          empresa_tipo: banco.empresa?.tipo || "",
          nome: banco.nome,
          codigo_banco: banco.codigo_banco,
          agencia: banco.agencia,
          conta: banco.conta,
          tipo: banco.tipo,
          saldo: Number(banco.saldo || 0),
        }))
        .sort((a, b) =>
          `${a.empresa}-${a.nome}`.localeCompare(`${b.empresa}-${b.nome}`)
        );
    },
    relatorioBancosPorEmpresa() {
      return (this.dashboard?.empresas || []).map((empresa) => ({
        id_empresa: Number(empresa.id_empresa),
        nome: this.nomeEmpresa(empresa),
        saldo: Number(empresa.metricas?.saldo_bancos || 0),
      }));
    },
    saldoBancosTotal() {
      return Number(this.dashboard?.totais?.saldo_bancos || 0);
    },
    contasBancariasNegativas() {
      return this.relatorioBancos.filter((banco) => banco.saldo < 0).length;
    },
    categoriasGraficos() {
      return this.relatorioVendas.map((empresa) => empresa.nome);
    },
    temFaturamento() {
      return this.relatorioVendas.some((empresa) => empresa.faturamento > 0);
    },
    graficoVendasSeries() {
      return [
        {
          name: "Faturamento",
          data: this.relatorioVendas.map((empresa) => empresa.faturamento),
        },
      ];
    },
    graficoVendasOptions() {
      return this.opcoesGraficoBarras(this.categoriasGraficos, ["#ee7361"]);
    },
    graficoParticipacaoSeries() {
      return this.relatorioVendas.map((empresa) => empresa.faturamento);
    },
    graficoParticipacaoOptions() {
      return {
        chart: {
          toolbar: { show: false },
          animations: { enabled: false },
          fontFamily: "inherit",
        },
        labels: this.categoriasGraficos,
        colors: ["#ee7361", "#3699ff", "#1bc5bd", "#8950fc", "#ffa800"],
        dataLabels: {
          formatter: (valor) => this.formatarPercentual(valor),
        },
        legend: {
          position: "bottom",
          fontFamily: "inherit",
        },
        plotOptions: {
          pie: {
            donut: {
              size: "62%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total",
                  formatter: () =>
                    this.formatarMoeda(this.dashboard?.totais?.faturamento),
                },
              },
            },
          },
        },
        tooltip: {
          y: { formatter: (valor) => this.formatarMoeda(valor) },
        },
      };
    },
    graficoFinanceiroSeries() {
      return [
        {
          name: "Recebido",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.receitas_recebidas
          ),
        },
        {
          name: "Pago",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.despesas_pagas
          ),
        },
        {
          name: "Resultado",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.resultado_periodo
          ),
        },
      ];
    },
    graficoFinanceiroOptions() {
      return this.opcoesGraficoBarras(this.categoriasGraficos, [
        "#1bc5bd",
        "#f64e60",
        "#3699ff",
      ]);
    },
    graficoContasSeries() {
      return [
        {
          name: "A receber",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.contas_receber
          ),
        },
        {
          name: "Receber vencido",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.contas_receber_vencidas
          ),
        },
        {
          name: "A pagar",
          data: this.relatorioFinanceiro.map((empresa) => empresa.contas_pagar),
        },
        {
          name: "Pagar vencido",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.contas_pagar_vencidas
          ),
        },
      ];
    },
    graficoContasOptions() {
      return this.opcoesGraficoBarras(this.categoriasGraficos, [
        "#1bc5bd",
        "#ffa800",
        "#8950fc",
        "#f64e60",
      ]);
    },
    graficoBancosSeries() {
      return [
        {
          name: "Saldo atual",
          data: this.relatorioBancosPorEmpresa.map((empresa) => empresa.saldo),
        },
      ];
    },
    graficoBancosOptions() {
      return this.opcoesGraficoBarras(
        this.relatorioBancosPorEmpresa.map((empresa) => empresa.nome),
        ["#3699ff"]
      );
    },
  },
  methods: {
    formatarDataInput(data) {
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },
    nomeEmpresa(empresa) {
      return (
        empresa?.nome_fantasia ||
        empresa?.nome ||
        `Empresa ${empresa?.id_empresa}`
      );
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(valor || 0));
    },
    formatarPercentual(valor) {
      return `${Number(valor || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}%`;
    },
    formatarMoedaCompacta(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        notation: "compact",
        maximumFractionDigits: 1,
      }).format(Number(valor || 0));
    },
    opcoesGraficoBarras(categorias, cores) {
      return {
        chart: {
          toolbar: { show: false },
          animations: { enabled: false },
          fontFamily: "inherit",
        },
        colors: cores,
        dataLabels: { enabled: false },
        plotOptions: {
          bar: {
            borderRadius: 4,
            columnWidth: "58%",
          },
        },
        xaxis: {
          categories: categorias,
          labels: {
            rotate: -25,
            trim: true,
          },
        },
        yaxis: {
          labels: {
            formatter: (valor) => this.formatarMoedaCompacta(valor),
          },
        },
        legend: {
          position: "bottom",
          fontFamily: "inherit",
        },
        grid: { borderColor: "#ebedf3" },
        tooltip: {
          y: { formatter: (valor) => this.formatarMoeda(valor) },
        },
      };
    },
    classeResultado(valor) {
      return Number(valor || 0) < 0 ? "text-danger" : "text-success";
    },
    selecionarTodas() {
      this.filtros.empresas = this.opcoesEmpresas.map((opcao) => opcao.value);
    },
    exportarVendas() {
      const linhas = this.relatorioVendas.map((empresa) => [
        empresa.nome,
        empresa.tipo,
        empresa.quantidade_vendas,
        empresa.faturamento,
        empresa.ticket_medio,
        empresa.participacao,
      ]);

      this.exportarCsv(
        "vendas",
        [
          "Empresa",
          "Tipo",
          "Quantidade de vendas",
          "Faturamento",
          "Ticket médio",
          "Participação (%)",
        ],
        linhas
      );
    },
    exportarFinanceiro() {
      const linhas = this.relatorioFinanceiro.map((empresa) => [
        empresa.nome,
        empresa.tipo,
        empresa.receitas_recebidas,
        empresa.despesas_pagas,
        empresa.resultado_periodo,
        empresa.contas_receber,
        empresa.contas_receber_vencidas,
        empresa.contas_pagar,
        empresa.contas_pagar_vencidas,
      ]);

      this.exportarCsv(
        "financeiro",
        [
          "Empresa",
          "Tipo",
          "Receitas recebidas",
          "Despesas pagas",
          "Resultado do período",
          "Contas a receber",
          "Contas a receber vencidas",
          "Contas a pagar",
          "Contas a pagar vencidas",
        ],
        linhas
      );
    },
    exportarBancos() {
      const linhas = this.relatorioBancos.map((banco) => [
        banco.empresa,
        banco.empresa_tipo,
        banco.nome,
        banco.codigo_banco,
        banco.tipo,
        banco.agencia,
        banco.conta,
        banco.saldo,
      ]);

      this.exportarCsv(
        "bancos",
        [
          "Empresa",
          "Tipo da empresa",
          "Banco/conta",
          "Código do banco",
          "Tipo da conta",
          "Agência",
          "Conta",
          "Saldo atual",
        ],
        linhas
      );
    },
    exportarCsv(tipo, cabecalho, linhas) {
      const escapar = (valor) => `"${String(valor ?? "").replace(/"/g, '""')}"`;
      const conteudo = [cabecalho, ...linhas]
        .map((linha) => linha.map(escapar).join(";"))
        .join("\n");
      const blob = new Blob([`\uFEFF${conteudo}`], {
        type: "text/csv;charset=utf-8;",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `grupo_${tipo}_${this.filtros.inicio}_${this.filtros.fim}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    async carregarInicial() {
      this.carregandoInicial = true;

      try {
        const { data } = await this.$http.get("/empresa/grupos/atual");
        this.grupo = data?.data || null;

        if (this.grupo) {
          this.selecionarTodas();
          await this.carregarDashboard();
        }
      } finally {
        this.carregandoInicial = false;
      }
    },
    async carregarDashboard() {
      if (!this.grupo?.id_grupo_empresa || this.filtros.empresas.length === 0) {
        return;
      }

      this.carregando = true;

      try {
        const { data } = await this.$http.get(
          `/empresa/grupos/${this.grupo.id_grupo_empresa}/dashboard`,
          {
            params: {
              inicio: this.filtros.inicio,
              fim: this.filtros.fim,
              empresas: this.filtros.empresas,
            },
          }
        );
        this.dashboard = data?.data || null;
      } finally {
        this.carregando = false;
      }
    },
  },
  mounted() {
    this.carregarInicial();
  },
};
